import Table from '@tiptap/extension-table';
import { columnResizing, tableEditing } from '@tiptap/pm/tables';

/**
 * This extension will ensure that we have <div class="tableWrapper"> around table in both edit mode and preview mode.
 * To do this we override addProseMirrorPlugins() method from original Table extension and use the same logic
 * but another condition. Original Table extension use such condition to add div wrapper:
 * const isResizable = this.options.resizable && this.editor.isEditable
 * Since we want to use wrapper in both modes we don't need to rely on this.editor.isEditable
 * P.S. This change is necessary because we need to add horizontal scrolling for session notes in case if table is much
 * bigger than width of actual session note dialog. If you need to change this logic make sure to test how session note
 * deals with wide tables
 */
const CustomTable = Table.extend({
  addProseMirrorPlugins() {
    return [
      ...(this.options.resizable
        ? [
          columnResizing({
            handleWidth: this.options.handleWidth,
            cellMinWidth: this.options.cellMinWidth,
            View: this.options.View,
            lastColumnResizable: this.options.lastColumnResizable,
          }),
        ]
        : []),

      tableEditing({
        allowTableNodeSelection: this.options.allowTableNodeSelection,
      }),
    ];
  },
});

export default CustomTable;
